import React from 'react'
import { Table, useMediaSize } from '@ally/metronome-ui'
import styled from 'styled-components'
import AccountGroup from '../../Shared/AccountGroup'
import AccountCard from '../../Shared/AccountCard'
import { getColumns, WealthTableData } from './TableColumns'
import MobileWealthClient from './MobileWealthClient'
import WealthManagementDrawer from './WealthManagementDrawer'
import { getWealthTableData, sortWealthAccountsGroup } from './utils'
import { useAccountTypes } from '../../AccountTypeContext'
import { useCustomizeDashboard } from '../../CustomizeDashboard/CustomizeDashboardContext/CustomizeDashboardContext'
import { hasStaleAccounts, isAccountClosed } from '../../utils'
import { NonPrintingWrapper } from '../../Shared/NonPrintingWrapper'
import AccountCardMbox from '../../Shared/AccountCardMbox'

const StyledTableWrapper = styled.div`
  ${({ theme: { space } }): string => `
    table {
      tbody {
        tr td {
          box-shadow: none;
          padding: ${space.xxs} ${space.xs};
          background-color: inherit;
        }
        tr:last-child td {
          padding-bottom: 0px;
        }
      }
  `}
`

const WealthManagement: React.FC = () => {
  const {
    isWealthPartialOutage,
    isWealthProspect,
    investAccounts,
  } = useAccountTypes()
  const [{ dashboardView }] = useCustomizeDashboard()
  const invwAccountsGroup = investAccounts.filter(
    account => account.type === 'INVW',
  )
  const sortedInvwAccounts = sortWealthAccountsGroup(invwAccountsGroup)
  const tableData: WealthTableData[] =
    sortedInvwAccounts.length > 0 ? getWealthTableData(sortedInvwAccounts) : []
  const isLgDown = useMediaSize('LgDown')
  const isMdDown = useMediaSize('MdDown')
  const isPrint = window.matchMedia('print').matches

  const hasOnlyClosedAccounts = sortedInvwAccounts.every(isAccountClosed)

  const hasStaleData = hasStaleAccounts(investAccounts)

  return (
    <>
      {sortedInvwAccounts.length > 0 ? (
        <AccountGroup name="wealth-client">
          <AccountCard type="INVW" allClosedAccounts={hasOnlyClosedAccounts}>
            {isMdDown && !isPrint ? (
              <MobileWealthClient
                totalValue={tableData[0].totalValue}
                hasOnlyClosedAccounts={hasOnlyClosedAccounts}
                hasStaleData={hasStaleData}
              />
            ) : (
              <StyledTableWrapper>
                <Table
                  data={tableData}
                  columns={getColumns({
                    hasOnlyClosedAccounts,
                    isLgDown,
                    isWealthPartialOutage,
                    view: dashboardView,
                    hasStaleData,
                  })}
                  captionText="Information about your Ally Wealth Management accounts"
                  drawer={
                    <WealthManagementDrawer
                      sortedInvwAccounts={sortedInvwAccounts}
                      hasStaleData={hasStaleData}
                    />
                  }
                  fullWidth
                  suppressMdDownLayout
                  withFooter={!hasOnlyClosedAccounts}
                  autoResetExpanded={false}
                />
              </StyledTableWrapper>
            )}
            {!isWealthProspect && (
              <NonPrintingWrapper>
                <AccountCardMbox name="ally-dashboard-wealth-well" />
              </NonPrintingWrapper>
            )}
          </AccountCard>
        </AccountGroup>
      ) : null}
    </>
  )
}

export default WealthManagement
